function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#27d397",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.089 14.518a1.187 1.187 0 0 0-1.672 0l-4.256 4.256-1.842-1.841A1.182 1.182 0 1 0 1.646 18.6l2.678 2.678a1.183 1.183 0 0 0 1.672 0l5.091-5.093a1.183 1.183 0 0 0 0-1.672z",
    transform: "translate(5.7 -5.773)",
    style: {
      fill: "#27d397"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconSuccess);
export default __webpack_public_path__ + "static/media/notification-icon-success.24c02873726b23c936ea07cd2836782c.svg";
export { ForwardRef as ReactComponent };